module.exports = "/_next/static/images/f591a761e49b049d0ed9b9b9ed486d9a-calendar3d.png.webp";